// put style here
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    formInput: {
      width: '100%',
      '& div fieldset': {
        borderColor: theme.palette.primary.dark,
      },
      '& div input': {
        paddingTop: 12,
        paddingBottom: 12,
      },
      '& input::placeholder': {
        color: '#9799B1 !important',
        opacity: 1,
        fontSize: '14px !important',
      },
      '& .MuiInputBase-input::placeholder': {
        color: '#9799B1 !important',
        opacity: 1,
        fontSize: '14px !important',
      },
    },
    error: {
      '& div fieldset': {
        borderColor: `${theme.palette.error.main} !important`,
      },
    },
    marginTop: {
      marginTop: 15,
    },
    fullWidth: {
      width: '100%',
    },
    btnPrimary: {
      textTransform: 'none',
      paddingTop: 20,
      paddingBottom: 20,
      paddingLeft: 20,
      paddingRight: 20,
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      '@media(min-width: 600px)': {},
    },
    textHeader: {
      display: 'none',
      marginLeft: 0,
      '@media(min-width: 600px)': {
        display: 'block',
      },
    },
    flexContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    overrideThumb: {
      display: 'inline-flex',
      borderRadius: 2,
      border: '1px solid #eaeaea',
      width: 'auto',
      height: 100,
      maxWidth: 100,
    },
    variableFormTitle: {
      fontFamily: 'Poppins',
      fontSize: 22,
      fontStyle: 'normal',
      fontWeight: 700,
      color: theme.palette.primary.light,
    },
    replaceTextContainer: {
      marginLeft: '3.7rem',
      marginTop: 7,
      color: theme.palette.primary.main,
      textDecoration: 'underline',
      fontFamily: 'Poppins',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 14,
      marginBottom: 5,
      cursor: 'pointer',
    },
    labelRadio: {
      '& .MuiFormControlLabel-label': {
        fontSize: 14,
      }
    },
    textareaInput: {
      width: '100%',
      height: '70px',
      fontSize: '14px',
      fontFamily: 'ITC Avant Garde Gothic Std Medium',
      border: "1px solid #353537ff",
      padding: 7,
      borderRadius: 5,
      boxSizing: 'border-box',
      resize: 'vertical',
      lineHeight: '1.4',
      '&::placeholder': {
        color: '#9799B1 !important',
        opacity: 1,
        fontSize: '14px !important',
      },
    }
  })
);
